import { ToastType } from "../../_theme/components/CustomSnackbar";

type SnackbarFn = (
  message: string,
  type?: ToastType,
  duration?: number
) => void;

let snackbarRef: SnackbarFn | null = null;

export const SnackbarService = {
  register(fn: SnackbarFn) {
    snackbarRef = fn;
  },

  show(
    message: string,
    type: ToastType = "primary",
    duration = 3000
  ) {
    snackbarRef?.(message, type, duration);
  },
};